import React from "react";
import LabelAndCheckbox from "../../common/form/labelAndCheckbox";
import Row from "../../common/layout/row";
import Grid from "../../common/layout/grid";
import { ModalAlert } from "../../common/dialog/modalAlert";
import { adicionarPontosMilhar } from "../../utils/adicionarPontosMilhar";

export function ModalFiltrosFaturasClienteEnergia(props) {
    if (!props.visible) return null;

    function getStyleSlimCard(bgColor, textColor) {
        return {
            borderRadius: 8,
            cursor: "pointer",
            backgroundColor: bgColor,
            color: textColor || "#000000",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "10px 10px 0px 10px",
            width: "100%",
            minHeight: "40px",
            margin: 5,
            boxShadow: "#9b9b9b 0px 1px 2px 1px",
        };
    }

    const empenhoSelecionado = props.exibirFiltroEmpenho ? props.listaEmpenho.find((emp) => emp.id == props.filtro.id_empenho) : null;

    return (
        <ModalAlert titulo="Filtrar Faturas" handleClose={props.handleClose}>
            <Row style={{ padding: 7 }}>
                <Grid cols={"12 12 12 12"}>
                    {props.usuarioLogado ? (
                        <div
                            style={{
                                width: "100%",
                                display: "flex",
                                flexWrap: "wrap",
                                marginBottom: 20,
                                minHeight: "fit-content",
                            }}
                        >
                            <Grid
                                cols={"12 12 6 6"}
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    cursor: "pointer",
                                }}
                            >
                                <label style={getStyleSlimCard("#6dc9ff")} htmlFor="filtro-todas">
                                    <LabelAndCheckbox
                                        style={{ justifyContent: "center" }}
                                        readOnly={props.aguardando}
                                        modoCard={true}
                                        colorIcon="#000"
                                        id="filtro-todas"
                                        label={`Mostrar todas (${props.quantidadesFiltro.qtdCorBranca + props.quantidadesFiltro.qtdCorAmarela + props.quantidadesFiltro.qtdCorAzul + props.quantidadesFiltro.qtdCorVerde + props.quantidadesFiltro.qtdCorVermelha})`}
                                        onChange={(e) =>
                                            props.setState({
                                                ...props.filtroState,
                                                statusCorBranca: e.target.checked,
                                                statusCorAzul: e.target.checked,
                                                statusCorAmarela: e.target.checked,
                                                statusCorVermelha: e.target.checked,
                                                statusCorVerde: e.target.checked,
                                            })
                                        }
                                        value={
                                            props.filtroState.statusCorBranca &&
                                            props.filtroState.statusCorAzul &&
                                            props.filtroState.statusCorAmarela &&
                                            props.filtroState.statusCorVermelha &&
                                            props.filtroState.statusCorVerde
                                        }
                                    />
                                </label>
                            </Grid>
                            <Grid
                                cols={"12 12 6 6"}
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    cursor: "pointer",
                                }}
                            >
                                <label style={getStyleSlimCard("rgb(255 239 113)")} htmlFor="filtro-amarelas">
                                    <LabelAndCheckbox
                                        style={{ justifyContent: "center" }}
                                        readOnly={props.aguardando}
                                        modoCard={true}
                                        colorIcon="#000"
                                        id="filtro-amarelas"
                                        label={`Um ou dois dias para o vencimento (${props.quantidadesFiltro.qtdCorAmarela})`}
                                        onChange={(e) =>
                                            props.setState({
                                                ...props.filtroState,
                                                statusCorAmarela: e.target.checked,
                                            })
                                        }
                                        value={props.filtroState.statusCorAmarela}
                                    />
                                </label>
                            </Grid>

                            <Grid
                                cols={"12 12 6 6"}
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    cursor: "pointer",
                                }}
                            >
                                <label style={getStyleSlimCard("rgb(255 101 105)")} htmlFor="filtro-vermelhas">
                                    <LabelAndCheckbox
                                        style={{ justifyContent: "center" }}
                                        readOnly={props.aguardando}
                                        modoCard={true}
                                        colorIcon="#000"
                                        id="filtro-vermelhas"
                                        label={`Vencendo hoje ou vencida (${props.quantidadesFiltro.qtdCorVermelha})`}
                                        onChange={(e) =>
                                            props.setState({
                                                ...props.filtroState,
                                                statusCorVermelha: e.target.checked,
                                            })
                                        }
                                        value={props.filtroState.statusCorVermelha}
                                    />
                                </label>
                            </Grid>
                            <Grid
                                cols={"12 12 6 6"}
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    cursor: "pointer",
                                }}
                            >
                                <label style={getStyleSlimCard("#44ffaa")} htmlFor="filtro-verdes">
                                    <LabelAndCheckbox
                                        style={{ justifyContent: "center" }}
                                        readOnly={props.aguardando}
                                        modoCard={true}
                                        colorIcon="#000"
                                        id="filtro-verdes"
                                        label={`Paga (${props.quantidadesFiltro.qtdCorVerde})`}
                                        onChange={(e) =>
                                            props.setState({
                                                ...props.filtroState,
                                                statusCorVerde: e.target.checked,
                                            })
                                        }
                                        value={props.filtroState.statusCorVerde}
                                    />
                                </label>
                            </Grid>
                            <Grid
                                cols={"12 12 6 6"}
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    cursor: "pointer",
                                }}
                            >
                                <label style={getStyleSlimCard("#f9f9f9")} htmlFor="filtro-brancas">
                                    <LabelAndCheckbox
                                        style={{ justifyContent: "center" }}
                                        readOnly={props.aguardando}
                                        modoCard={true}
                                        colorIcon="#000"
                                        id="filtro-brancas"
                                        label={`Não importado (${props.quantidadesFiltro.qtdCorBranca})`}
                                        onChange={(e) =>
                                            props.setState({
                                                ...props.filtroState,
                                                statusCorBranca: e.target.checked,
                                            })
                                        }
                                        value={props.filtroState.statusCorBranca}
                                    />
                                </label>
                            </Grid>
                            <Grid
                                cols={"12 12 6 6"}
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                }}
                            >
                                <label style={getStyleSlimCard("rgb(197 255 255)")} htmlFor="filtro-azuis">
                                    <LabelAndCheckbox
                                        style={{ justifyContent: "center" }}
                                        readOnly={props.aguardando}
                                        modoCard={true}
                                        colorIcon="#000"
                                        id="filtro-azuis"
                                        label={`Importada e não vencida (${props.quantidadesFiltro.qtdCorAzul})`}
                                        onChange={(e) =>
                                            props.setState({
                                                ...props.filtroState,
                                                statusCorAzul: e.target.checked,
                                            })
                                        }
                                        value={props.filtroState.statusCorAzul}
                                    />
                                </label>
                            </Grid>
                        </div>
                    ) : null}
                </Grid>
                {props.exibirFiltroEmpenho ? (
                    <Grid
                        cols="12 12 12 12"
                        style={{
                            padding: empenhoSelecionado ? 13 : 0,
                            textAlign: "center",
                            minHeight: "fit-content",
                            backgroundColor: "#BA0000",
                            color: "#FFFFFF",
                            borderRadius: "0.4rem",
                            boxShadow: "#9b9b9b 0px 1px 2px 1px",
                            fontSize: window.innerWidth < 768 ? "0.7rem" : "0.9rem",
                        }}
                    >
                        {empenhoSelecionado ? null : (
                            <Row alignCenter style={{ paddingTop: 5 }}>
                                <b
                                    style={{
                                        padding: "4px 10px",
                                        backgroundColor: "#ff2c2c",
                                        borderRadius: "0.3rem",
                                    }}
                                >
                                    (selecione um empenho para análise)
                                </b>
                            </Row>
                        )}
                        <Row alignCenter style={{ paddingTop: empenhoSelecionado ? 10 : 0 }}>
                            <h5
                                style={{
                                    width: "90%",
                                    borderRadius: "0.4rem",
                                    padding: 5,
                                    backgroundColor: "#EAEDEE",
                                    color: "#2B2A2A",
                                }}
                            >
                                Acompanhamento de Empenho
                            </h5>
                        </Row>
                        <Row>
                            <Grid
                                cols="8 8 8 8"
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "end",
                                    textAlign: "end",
                                }}
                            >
                                <b>Valor previsto para empenho:</b>
                            </Grid>
                            <Grid cols="4 4 4 4" style={{ textAlign: "left" }}>
                                <b>
                                    <div
                                        style={{
                                            maxWidth: "9rem",
                                            padding: 5,
                                            borderRadius: "0.4rem",
                                            backgroundColor: empenhoSelecionado ? "#1A9EC9" : "",
                                        }}
                                    >
                                        {empenhoSelecionado ? "R$ " + adicionarPontosMilhar(String(empenhoSelecionado.valor_previsto).replace(".", ",")) : "R$ 0,00 "}
                                    </div>
                                </b>
                            </Grid>
                        </Row>
                        <Row>
                            <Grid
                                cols="8 8 8 8"
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "end",
                                    textAlign: "end",
                                }}
                            >
                                <b>Valor total utilizado em todo período do empenho:</b>
                            </Grid>
                            <Grid cols="4 4 4 4" style={{ textAlign: "left" }}>
                                <b>
                                    <div
                                        style={{
                                            maxWidth: "9rem",
                                            padding: 5,
                                            borderRadius: "0.4rem",
                                            backgroundColor: empenhoSelecionado ? "#FE9A24" : "",
                                        }}
                                    >
                                        {empenhoSelecionado ? "R$ " + adicionarPontosMilhar(String(props.totalFaturaEmpenho).replace(".", ",")) : "R$ 0,00 "}
                                    </div>
                                </b>
                            </Grid>
                        </Row>
                        <Row>
                            <Grid
                                cols="8 8 8 8"
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "end",
                                    textAlign: "end",
                                }}
                            >
                                <b>Valor total do empenho disponível:</b>
                            </Grid>
                            <Grid cols="4 4 4 4" style={{ textAlign: "left" }}>
                                <b>
                                    <div
                                        style={{
                                            maxWidth: "9rem",
                                            padding: 5,
                                            borderRadius: "0.4rem",
                                            backgroundColor: !empenhoSelecionado
                                                ? ""
                                                : parseFloat(empenhoSelecionado.valor_previsto - props.totalFaturaEmpenho) >= 0
                                                  ? "#43B743"
                                                  : "#FF4141",
                                        }}
                                    >
                                        {empenhoSelecionado
                                            ? "R$ " + adicionarPontosMilhar(String(parseFloat(empenhoSelecionado.valor_previsto - props.totalFaturaEmpenho)).replace(".", ","))
                                            : "R$ 0,00 "}
                                    </div>
                                </b>
                            </Grid>
                        </Row>
                    </Grid>
                ) : null}
            </Row>
        </ModalAlert>
    );
}
